export const remarksListArray = [
  {
    id: 1,
    remarkType: 'AIRPORT',
    remarkText: `In the Remarks section, we need to show what Remarks are already associated with the airport and have the ability to add, edit and delete Remarks.`,
  },
  {
    id: 2,
    remarkType: 'RUNWAY',
    remarkText: `In the Remarks section, we need to show what Remarks are already associated with the airport and have the ability to add, edit and delete Remarks.`,
  },
  {
    id: 3,
    remarkType: 'TAXIWAY',
    remarkText: `In the Remarks section, we need to show what Remarks are already associated with the airport and have the ability to add, edit and delete Remarks.`,
  },
  {
    id: 4,
    remarkType: 'SPECIAL',
    remarkText: `In the Remarks section, we need to show what Remarks are already associated with the airport and have the ability to add, edit and delete Remarks.`,
  },
];

export const remarksHeadersArray = [
  { title: 'Remarks Type', field: 'remarkElementName', defaultSort: 'asc' },
  { title: 'Remarks Text', field: 'remarkText' },
];

export const remarkType = [
  { itemValue: 'AIRPORT', itemLabel: 'AIRPORT' },
  { itemValue: 'RUNWAY', itemLabel: 'RUNWAY' },
  { itemValue: 'TAXIWAY', itemLabel: 'TAXIWAY' },
  { itemValue: 'RAMP', itemLabel: 'RAMP' },
  { itemValue: 'SPECIAL', itemLabel: 'SPECIAL' },
  { itemValue: 'INTL ARRIVAL', itemLabel: 'INTL ARRIVAL' },
  { itemValue: 'INTERNAL USE', itemLabel: 'INTERNAL USE' },
];
